import React, { useEffect, useRef, useState } from 'react';
import { colors, FONT, radii } from '../../../theme';

/**
 * A few seconds to take it back.
 *
 * Blocking is reversible, so the screen offers the reversal where the mistake
 * happens rather than making somebody find the person again and open their
 * card. That is the whole reason bulk blocking is allowed and bulk deleting is
 * not: one of them can be undone from here.
 *
 * The countdown is measured against the clock rather than counted in timer
 * ticks: a WebView throttles timers the moment the app is backgrounded, so a
 * tick-counted toast would still be sitting there tomorrow.
 */
export default function UndoToast({ text, actionLabel = 'Отменить', onAction, onExpire, ms = 5000 }) {
  const [left, setLeft] = useState(Math.ceil(ms / 1000));
  const startedAt = useRef(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      const passed = Date.now() - startedAt.current;
      if (passed >= ms) { clearInterval(timer); onExpire?.(); return; }
      setLeft(Math.ceil((ms - passed) / 1000));
    }, 250);
    return () => clearInterval(timer);
  }, [ms]); // eslint-disable-line

  return (
    <div style={{
      position: 'fixed', left: 16, right: 16,
      bottom: 'calc(80px + env(safe-area-inset-bottom) + 12px)',
      zIndex: 60, background: colors.gray900, color: colors.white,
      borderRadius: radii.sm, padding: '14px 16px', fontFamily: FONT, fontSize: 14,
      display: 'flex', alignItems: 'center', gap: 12,
      boxShadow: '0 6px 24px rgba(0,0,0,0.35)',
    }}>
      <span style={{ flex: 1 }}>{text}</span>
      <button onClick={onAction}
        style={{
          background: 'none', border: 'none', color: colors.white, fontFamily: FONT,
          fontSize: 14, fontWeight: 600, cursor: 'pointer', minHeight: 44, padding: '0 4px',
        }}>
        {actionLabel} · {left}
      </button>
    </div>
  );
}
